export default __webpack_public_path__ + "static/media/dichoi.8d585dc4.jpg";